module.exports = __webpack_public_path__ + "img/download-app-popup-v11032022.1dcccffb.svg";